module.exports = __webpack_public_path__ + "img/bg-light.a050478f.jpg";